import React, {Fragment, Suspense} from 'react';
import MasterLayout from "../../components/MasterLayout/MasterLayout";
import LazyLoader from "../../components/MasterLayout/LazyLoader";
import ProductCreate from './../../components/Product/ProductCreate';

const ProductCreatePage = () => {
    return (
        <Fragment>
            <MasterLayout>
                <Suspense fallback={<LazyLoader/>}>
                    <ProductCreate/>
                </Suspense>
            </MasterLayout>
        </Fragment>
    );
};

export default ProductCreatePage;